export default __webpack_public_path__ + "static/media/firebase.fe69c615.png";